/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FieldDisplayWrapper } from "cms/fields/layout/field-display-wrapper";
import { FieldDocument } from "cms/documents/document/field-document";
import { useCurrentDynamicField } from "cms/fields/hooks/use-current-dynamic-field";
import { isArrayNotEmpty } from "utils/empty-exists";

const DocumentFieldDisplay = () => {
    
    const { field } = useCurrentDynamicField();
    const { values } = field || {}; //name, type, values, settings: fieldSettings
    
    return (
        <FieldDisplayWrapper>
            <div className='as-list-container'>
                {isArrayNotEmpty(values) &&
                    values.map((item, index) => {
                        const { value, settings } = item || {};
                        const { style, format, options } = settings || {};
                        return (
                            <FieldDocument
                                key={index}
                                document={value}
                                style={style}
                                format={format}
                                options={options}
                            />
                        );
                    })
                }
            </div>
        </FieldDisplayWrapper>
    );
};
DocumentFieldDisplay.displayName = "DocumentFieldDisplay";
export { DocumentFieldDisplay };


// //TODO: value is a document guid. need to call the document api and load details
// const document = {
//     guid: '1afb8ea8-b798-43fe-8e51-6a7cc8d06b78',
//     organization: '229dc6b8-b28d-459f-881e-f699cf7f3a1a',
//     title: 'Sample Document',
//     description: null,
//     storage_account: 'simplicityappdocuments',
//     storage_container: 'documents',
//     storage_filepath: 'sample_doc.pdf',
//     storage_url: 'https://simplicityappdocuments.blob.core.windows.net/documents/sample_doc.pdf',
//     url: 'https://documents-dnv.simplicitycms.ca/documents/sample_doc.pdf',
//     file_name: 'sample_doc.pdf',
//     file_ext: 'pdf',
//     file_type: 'application/pdf',
//     file_size: 3121975,
//     updated_at: '2022-10-13 20:12:59',
//     updated_by: '852725ec-ac64-452b-be05-e3b8f123a5bf',
//     created_at: '2022-10-13 20:12:59',
//     created_by: '852725ec-ac64-452b-be05-e3b8f123a5bf',
// }
